import {AxiosError} from "axios";
import {ApiConfig} from "components/src/api/admin/ApiConfig";
import {AuthApi, OAuth2ClientRegistrationDetails} from "components/src/api/admin/generated";
import {XSRF} from "components/src/auth//Xsrf";
import {SavedLocation} from "components/src/auth/SavedLocation";
import {LocaleSelector} from "components/src/common/LocaleSelector";
import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {logger} from "components/src/utils/Logger";
import {useEffect, useRef, useState} from "react";
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from 'react-bootstrap/Form';
import {useSearchParams} from "react-router-dom";

/**
 * REST api for accessing the back-end
 */
const authApi = new AuthApi(ApiConfig.config());

export const Login = () =>
{
    const [searchParams] = useSearchParams();

    /**
     * A ref to the hidden _csrf form field
     */
    const csrFieldRef = useRef<HTMLInputElement>(null);

    const loginURL: string = "/api/login"

    /**
     * The OIDC end-points
     */
    const [oidcEndPoints, setOidcEndPoints] = useState<OAuth2ClientRegistrationDetails[]>();

    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    // back-end will add the logout parameter when the user is logged out
    if (searchParams.has("logout")) {
        SavedLocation.clearSavedLocation();
    }

    function onSubmit()
    {
        if (csrFieldRef.current !== null) {
            csrFieldRef.current.value = XSRF.getCookie();
        }
    }

    useEffect(() =>
    {
        authApi.authControllerGetOIDCClients()
            .then(response =>
            {
                setOidcEndPoints(response.data)
            })
            .catch((err: Error | AxiosError) => {
                logger.error("Error getting OIDC clients", err);
            })
    }, []);

    return (
        <Form method="post" action={loginURL} onSubmit={onSubmit} className="w-100 p-4 shadow-sm rounded bg-body">
            <div className="mb-4 text-center">
                <h2>{t("login.please-login")}</h2>
            </div>

            {searchParams.has("error") && <Alert variant="danger">{t('login.login-failure')}</Alert>}

            <FloatingLabel label={t("login.username")} className="text-secondary mb-3">
                <Form.Control type="text" name="username" placeholder="Username" autoFocus/>
            </FloatingLabel>

            <FloatingLabel label={t("login.password")} className="text-secondary mb-3">
                <Form.Control type="password" name="password" placeholder="Password"/>
            </FloatingLabel>

            {oidcEndPoints !== undefined && oidcEndPoints.length > 0 && (
                <>
                    <Form.Text id="passwordHelpBlock" muted className="mb-2 d-block">{t('login.oidc-login')}</Form.Text>
                    {oidcEndPoints.map(endpoint => (
                        <div key={endpoint.clientId} className="mb-1">
                            <a href={endpoint.loginRedirectUri}>{endpoint.clientName}</a>
                        </div>
                    ))}
                </>
            )}

            <Button variant="success" type="submit" className="w-100 mt-4">
                {t("login.login")}
            </Button>

            <LocaleSelector className="w-auto mt-4" />

            <input name="_csrf" type="hidden" ref={csrFieldRef} value=""/>
        </Form>
    );
}
